import groupBy from 'lodash/groupBy';
import isEmpty from 'lodash/isEmpty';

import type { TCabinCategory } from '@/helpers/api/graphql/queries/cabinCategoriesAvailability';
import type { TCurrencyCode } from '@/types';

import getSymbolFromCurrenciesData from '@/helpers/util/currency/currencySymbols';

const getMaxDiscountForCabins = (cabins: TCabinCategory[]) =>
  cabins.reduce((max, cabin) => {
    const discount = Math.abs(cabin.lowestSubCategoryPrice?.totalPrice?.discount ?? 0);

    return max > discount ? max : discount;
  }, 0);

export const getDiscountValues = (cabinCategories: TCabinCategory[], currencyCode: TCurrencyCode) => {
  if (isEmpty(cabinCategories)) return {};

  const { false: nonVipCabins = [], true: vipCabins = [] } = groupBy(cabinCategories, 'isVip');

  const nonVipMaxDiscount = getMaxDiscountForCabins(nonVipCabins);
  const vipMaxDiscount = getMaxDiscountForCabins(vipCabins);

  return {
    cabinDiscount: nonVipMaxDiscount,
    currency: getSymbolFromCurrenciesData(currencyCode || 'USD'),
    isCabinAndSuitesDiscountAvailable: nonVipMaxDiscount > 0 && vipMaxDiscount > 0,
    isCabinDiscountAvailable: nonVipMaxDiscount > 0,
    isSuitesDiscountAvailable: vipMaxDiscount > 0,
    suitesDiscount: vipMaxDiscount,
  };
};
